import actionsLogState from './components/ActionsLog/ActionsLog-state';
import actionsState from './components/Player/Actions-state';
import appState from './App-state';
import chatState from './components/Chat/Chat-state';
import decreesBarState from './components/DecreesBar/DecreesBar-state';
import directMessagesState from './components/DirectMessagesWidget/DirectMessagesWidget-state';
import draftState from './components/DraftArea/DraftArea-state';
import gameState from './components/Game/Game-state';
import leaderboardState from './components/Leaderboard/Leaderboard-state';
import loginState from './components/Login/Login-state';
import matchesState from './components/Matches/Matches-state';
import modalState from './components/Modal/Modal-state';
import opponentSearchBarState from './components/OpponentSearchBar/OpponentSearchBar-state';
import recentMatchesState from './components/RecentMatches/RecentMatches-state';
import replayState from './components/Replay/Replay-state';
import roomListState from './components/RoomList/RoomList-state';
import soundState from './components/Sound/Sound-state';
import timeoutState from './components/Timeout/Timeout-state';
import timeoutBlitzState from './components/TimeoutBlitz/TimeoutBlitz-state';
import undoState from './components/Undo/Undo-state';
import usersState from './components/Users/Users-state';

const appStore = {
    modules: {
        actionsLogState,
        actionsState,
        appState,
        chatState,
        decreesBarState,
        directMessagesState,
        draftState,
        gameState,
        leaderboardState,
        loginState,
        recentMatchesState,
        matchesState,
        modalState,
        opponentSearchBarState,
        replayState,
        roomListState,
        soundState,
        timeoutState,
        timeoutBlitzState,
        undoState,
        usersState,
    },
};

export default appStore;
